/***
*
*   FEEDBACK METRICS
*   Three stat cards: Positive / Neutral / Negative comment counts.
*
**********/

import { Icon } from 'components/lib';
import { TEXT } from './constants';
import Style from './metrics.tailwind.js';

const CARDS = [
  { key: 'positive', label: TEXT.metricPositive, cardCls: Style.positive, countCls: Style.positiveCount, iconName: 'smile', iconColor: '#16a34a' },
  { key: 'neutral',  label: TEXT.metricNeutral,  cardCls: Style.neutral,  countCls: Style.neutralCount,  iconName: 'meh',   iconColor: '#ca8a04' },
  { key: 'negative', label: TEXT.metricNegative, cardCls: Style.negative, countCls: Style.negativeCount, iconName: 'frown', iconColor: '#dc2626' },
];

export function FeedbackMetrics({ data, loading }) {
  return (
    <div className={Style.row}>
      {CARDS.map(card => (
        <div key={card.key} className={`${Style.card} ${card.cardCls}`}>
          <div>
            <div className={Style.label}>{card.label}</div>
            <div className={`${Style.count} ${card.countCls}`}>
              {loading ? '\u2014' : (data[card.key] ?? 0).toLocaleString()}
            </div>
          </div>
          <Icon image={card.iconName} color={card.iconColor} size={28} />
        </div>
      ))}
    </div>
  );
}
